import { datetime } from '@codegrade/utils';
/**
 * Formats the boundary date to account for the full minute.
 *
 * @param minDate The optional minDate passed to the component `config` prop.
 * @returns The Minimum date for the FlatPickr configuration set
 * to the start of the minute if present in the configuration.
 */
export function formatMinDate(minDate) {
    if (minDate != null) {
        return datetime.formatDate(minDate.clone().startOf('minute'));
    }
    else {
        return undefined;
    }
}
/**
 * Formats the boundary date to account for the full minute.
 *
 * @param maxDate The optional maxDate passed to the component `config` prop.
 * @returns The Maximum date for the FlatPickr configuration set
 * to the end of the minute if present in the configuration.
 */
export function formatMaxDate(maxDate) {
    if (maxDate != null) {
        return datetime.formatDate(maxDate.clone().endOf('minute'));
    }
    else {
        return undefined;
    }
}
